import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import { useAwsCredentialsManager } from '../../context/AWS-credentials.context'

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    padding: theme.spacing(2),
    maxWidth: '90%',
    margin: '0 auto',
    fontFamily: "'Poppins', sans-serif",
  },
  logoContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: theme.spacing(5),
    fontFamily: "'Poppins', sans-serif",
  },
  plusIconWrapper: {
    marginBottom: theme.spacing(1),
    display: 'flex',
    justifyContent: 'center',
  },
  subtitle: {
    color: '#999',
    fontSize: '1.6rem',
    marginTop: theme.spacing(1.5),
    fontFamily: "'Poppins', sans-serif",
  },
  welcomeText: {
    textAlign: 'center',
    fontSize: '1.8rem',
    color: '#005DAA',
    lineHeight: 1.4,
    fontWeight: 500,
    width: '100%',
    fontFamily: "'Poppins', sans-serif",
  },
}))

const EmptyChat = () => {
  const classes = useStyles()
  const { isAuthorized } = useAwsCredentialsManager()

  return (
    <div className={classes.container}>
      <div className={classes.logoContainer}>
        <div className={classes.plusIconWrapper}>
          <PlusIcon size={100} style={{}} />
        </div>
        <Typography className={classes.subtitle}>Advertising & Marketing Insights</Typography>
      </div>

      {isAuthorized ? (
        <Typography className={classes.welcomeText}>
          Your agentic chat assistant for comparing bids, analyzing briefs, budgets and statements
          of work.
        </Typography>
      ) : (
        <Typography className={classes.welcomeText}>
          Please contact your Prodigy Administrator to activate Plus Chat.
        </Typography>
      )}
    </div>
  )
}

const PlusIcon = ({ size = 28, style = {} }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 100 100"
    fill="none"
    style={style}
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="50" cy="50" r="50" fill="#ff8a7b" />
    <rect x="26" y="43" width="50" height="15" fill="#323b60" />
    <rect x="43" y="26" width="16" height="50" fill="#323b60" />
  </svg>
)

export default EmptyChat
